import React from 'react';
import MembershipCard from './MembershipCard';
import { MEMBERSHIP_CARDS } from '@/shared/constants/existing-brands';
import './index.less';

const MembershipBenefits = () => {
  return (
    <div className="membership-benefits">
      <div className="membership-benefits-container">
        <div className="header">
          <h1>
            <span>Get cost-plus pricing</span> for your e-commerce brand.
          </h1>
          <p>Pietra&apos;s modular platform allows you to pick which parts of your business you want to streamline.</p>
        </div>
        <div className="values-add">
          {MEMBERSHIP_CARDS.map(({ title, description, image }) => (
            <MembershipCard key={image.link} title={title} description={description} image={image} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MembershipBenefits;
